module.exports = __webpack_public_path__ + "static/media/sub_competency_active.e76c7aad.svg";